export const waitFor = (ms: number) => new Promise<void>((res) => setTimeout(() => res(), ms))
